var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.653,
    height: 25.62,
    viewBox: "0 0 25.653 25.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7481",
    "data-name": "Path 7481",
    className: "cls-1",
    d: "M37.8,30.71l5.175-2.85a.9.9,0,0,0,.375-.675.862.862,0,0,0-.45-.675l-22.05-8.325a.817.817,0,0,0-.825.15.685.685,0,0,0-.15.825l8.4,22.05a.656.656,0,0,0,.675.45.7.7,0,0,0,.675-.375l2.85-5.175L39.9,43.535a.725.725,0,0,0,1.05,0l4.275-4.275a.725.725,0,0,0,0-1.05Zm2.625,11.175L32.849,34.31a.681.681,0,0,0-.525-.225h-.075a.564.564,0,0,0-.525.375l-2.55,4.575-7.2-18.975,18.975,7.2-4.575,2.55c-.225.15-.375.3-.375.525a.852.852,0,0,0,.225.6L43.8,38.51Z",
    transform: "translate(-19.796 -18.14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouse);
export default __webpack_public_path__ + "static/media/icon_mouse.645035e0bc7694c8f93ce7db42d90670.svg";
export { ForwardRef as ReactComponent };